import { render } from "./AppView.vue?vue&type=template&id=42ad3670&scoped=true"
import script from "./AppView.vue?vue&type=script&lang=js"
export * from "./AppView.vue?vue&type=script&lang=js"

import "./AppView.vue?vue&type=style&index=0&id=42ad3670&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ad3670"]])

export default __exports__